import { Popover } from 'antd';
import { Clock, IconProps } from 'react-feather';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

interface Props extends IconProps {
  redirect?: string;
  disabled?: boolean;
  popover?: string;
}

const ClockIcon: React.FC<Props> = ({
  popover,
  redirect,
  disabled,
  ...iconProps
}) => {
  const intl = useIntl();

  const icon = (
    <Clock
      size={20}
      cursor={'pointer'}
      {...iconProps}
      onClick={!disabled ? iconProps?.onClick : undefined}
      style={{
        cursor: disabled ? 'not-allowed' : undefined,
        color: disabled ? 'darkgray' : undefined,
        pointerEvents: disabled ? 'none' : undefined,
      }}
    />
  );

  return (
    <Popover
      content={
        popover ||
        intl.formatMessage({ id: 'commons.list.action.button.clock' })
      }
      className="edit-icon"
    >
      {redirect ? (
        <span
          style={{
            cursor: disabled ? 'not-allowed' : undefined,
          }}
        >
          <Link
            to={redirect}
            style={{
              pointerEvents: disabled ? 'none' : undefined,
            }}
          >
            {icon}
          </Link>
        </span>
      ) : (
        icon
      )}
    </Popover>
  );
};

export default ClockIcon;
